import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar fixed-top navbar-light border-bottom\" style=\"background-color:#fff !important;\"><div class=\"container\"><a class=\"navbar-brand\"></a><div class=\"d-flex\"><p class=\"tagline fs-5 mb-0 d-none d-sm-block\"> Education, guidance and a safe harbour to advice </p></div></div></nav>", 1)
const _hoisted_3 = { class: "container main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_landing = _resolveComponent("landing")!
  const _component_start = _resolveComponent("start")!
  const _component_philosophy = _resolveComponent("philosophy")!
  const _component_identify = _resolveComponent("identify")!
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_educational_video = _resolveComponent("educational-video")!
  const _component_question_view = _resolveComponent("question-view")!
  const _component_haves = _resolveComponent("haves")!
  const _component_risk = _resolveComponent("risk")!
  const _component_outcome = _resolveComponent("outcome")!
  const _component_terminus_guiide = _resolveComponent("terminus-guiide")!
  const _component_terminus_origen = _resolveComponent("terminus-origen")!
  const _component_dev_options = _resolveComponent("dev-options")!
  const _component_admin = _resolveComponent("admin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLanding)
      ? (_openBlock(), _createBlock(_component_landing, {
          key: 0,
          onNextClicked: _ctx.onLandingNextClicked
        }, null, 8, ["onNextClicked"]))
      : _createCommentVNode("", true),
    (_ctx.showStart)
      ? (_openBlock(), _createBlock(_component_start, {
          key: 1,
          onNextClicked: _ctx.onStartNextClicked
        }, null, 8, ["onNextClicked"]))
      : _createCommentVNode("", true),
    (_ctx.showPhilosophy)
      ? (_openBlock(), _createBlock(_component_philosophy, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.showIdentify)
      ? (_openBlock(), _createBlock(_component_identify, {
          key: 3,
          onNextClicked: _ctx.onIdentifyNextClicked
        }, null, 8, ["onNextClicked"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("main", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_breadcrumb),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showEducationVideo)
          ? (_openBlock(), _createBlock(_component_educational_video, {
              key: 0,
              onNextClicked: _ctx.onEducationalVideoNextClicked
            }, null, 8, ["onNextClicked"]))
          : _createCommentVNode("", true),
        (_ctx.showUserQuestions)
          ? (_openBlock(), _createBlock(_component_question_view, {
              key: 1,
              ref: "aQuestionView",
              question: _ctx.question,
              isFirstQuestion: _ctx.isFirstQuestion,
              onAnswered: _ctx.onAnswered,
              onPreviousClicked: _ctx.onQuestionPreviousClicked
            }, null, 8, ["question", "isFirstQuestion", "onAnswered", "onPreviousClicked"]))
          : _createCommentVNode("", true),
        (_ctx.showCalculation)
          ? (_openBlock(), _createBlock(_component_haves, {
              key: 2,
              onPreviousClicked: _ctx.onHavesPreviousClicked,
              onNextClicked: _ctx.onHavesNextClicked
            }, null, 8, ["onPreviousClicked", "onNextClicked"]))
          : _createCommentVNode("", true),
        (_ctx.showRisk)
          ? (_openBlock(), _createBlock(_component_risk, {
              key: 3,
              onNextClicked: _ctx.moveToNextSection
            }, null, 8, ["onNextClicked"]))
          : _createCommentVNode("", true),
        (_ctx.showOutcome)
          ? (_openBlock(), _createBlock(_component_outcome, { key: 4 }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_terminus_guiide, {
          ref: "terminus",
          onGoBackToStart: _ctx.onTerminusGoBackToStart
        }, null, 8, ["onGoBackToStart"]), [
          [_vShow, _ctx.showTerminusGuiide]
        ]),
        _withDirectives(_createVNode(_component_terminus_origen, {
          ref: "terminus",
          onGoBackToStart: _ctx.onTerminusGoBackToStart
        }, null, 8, ["onGoBackToStart"]), [
          [_vShow, _ctx.showTerminusOrigen]
        ]),
        (_ctx.showDPanel)
          ? (_openBlock(), _createBlock(_component_dev_options, {
              key: 5,
              onKeyQuestionsChanged: _ctx.onKeyQuestionsChanged
            }, null, 8, ["onKeyQuestionsChanged"]))
          : _createCommentVNode("", true),
        (_ctx.showAdmin)
          ? (_openBlock(), _createBlock(_component_admin, { key: 6 }))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.showBreadcrumbs]
    ])
  ], 64))
}